import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LayoutService } from './services/layout/app.layout.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  isLogoLoading$: Observable<boolean>;

  constructor(private layoutService: LayoutService) {
    this.isLogoLoading$ = this.layoutService.isLogoLoading$;
  }

  ngOnInit() {
    this.layoutService.GetLogo();
  }
}